export default class sliderManager {
    constructor(){

        this.showPc = 0;
        this.showSmp = 0;

    }
    init(){

        let _this = this;
        // this.showPc = document.querySelector('.js__slider').dataset['showpc'];
        // this.showSmp = document.querySelector('.js__slider').dataset['showsmp'];

        let mySwiper = new Swiper ('.swiper-container', {
            loop: true,
            speed: 400,
            slidesPerView: 3,
            spaceBetween: 100,
            direction: 'horizontal',
            effect: 'slide',
            centeredSlides: true,
            autoplay: false,
            // autoplay: {
            //     delay: 3000, // スライドが切り替わるまでの表示時間(ミリ秒)
            //     stopOnLast: false, // 最後のスライドまで表示されたら自動再生を中止するか
            //     disableOnInteraction: true // ユーザーのスワイプ操作を検出したら自動再生を中止するか
            // },

            breakpoints: {
                // 980ピクセル幅以下になったら
                750: {
                    slidesPerView: 1,
                    spaceBetween: 25
                }
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },

            navigation: {
                nextEl: '.swiper-button-next', // 次のスライドボタンのセレクタ
                prevEl: '.swiper-button-prev', // 前のスライドボタンのセレクタ
            },

            // scrollbar: {
            //     el: '.swiper-scrollbar', // スクロールバーを表示するセレクタ
            // }

        });

    }

    resize(){

    }


}